<template>
  <div class="box">
    <div class="main">
      <div
        class="for"
        @click="selectPeople(infor)"
        v-for="(infor, index) in list"
        :key="index"
      >
        <div class="people">
          <i
            class="iconfont1 icon-user-wait"
            style="color: #3478f7; font-size: 17px; padding-right: 3px"
          ></i>
          <span>就诊人：</span>{{ infor.patientName }}
        </div>
        <div class="information">
          <span>身份证号：</span>
          {{ infor.idCard }}
        </div>
        <div class="information">
          <span>就诊卡号：</span>
          {{ infor.patientIdCard ? infor.patientIdCard : '暂无' }}
        </div>
        <van-row class="row">
          <van-col span="8">
            <div
              class="dis"
              v-if="infor.mark != 0"
              style="border-right:1px solid #969799"
              @click.stop="bindMark(infor.patientId)"
            >
              设为默认
            </div>
            <div
              class="dis"
              v-if="infor.mark == 0"
              style="border-right:1px solid #969799"
            >
              <van-icon
                name="checked"
                color="#3478f7"
                style="margin-right:5px"
              />
              默认
            </div>
          </van-col>
          <!-- <van-col span="8" @click.stop="lookCode">
            <div class="dis" style="border-right:1px solid #969799">
              <i
                class="iconfont icon-ico"
                style="font-size:17px;padding-right:3px"
              ></i
              >二维码
            </div>
          </van-col> -->
          <!-- <van-col span="8">
            <div class="dis" @click.stop="openDelModel(infor.patientId)" style="border-right:1px solid #969799">
              <van-icon name="delete" size="18" style="margin-right:3px" />删除
            </div>
          </van-col>
          <van-col span="8">
            <div class="dis" @click.stop="changeModel(infor.patientId)">
              <van-icon name="delete" size="18" style="margin-right:3px" />编辑
            </div>
          </van-col> -->
        </van-row>
      </div>
      <van-empty
        v-if="!list.length"
        class="custom-image"
        image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        description="暂无就诊人，请添加就诊人"
      />
    </div>
    <div class="footer">
      <van-button type="info" :round="true" size="normal" @click="addp"
        >添加就诊人</van-button
      >
    </div>
  </div>
</template>

<script>
import { getPatient, deletePatient, setPatient } from '@/api/api'
import { Dialog, Toast } from 'vant'
export default {
  name: 'patientList',
  data() {
    return {
      list: []
    }
  },
  created() {},
  mounted() {
    this.getList()
  },
  methods: {
    bindMark(id) {
      setPatient(id).then(res => {
        if (res.code == 200) {
          Toast.success('设置默认就诊人成功')
          this.getList()
        } else {
          Toast.fail('设置失败')
        }
      })
    },
    changeModel(id) {
      this.$router.push({
        name: 'changePatient',
        query: { id }
      })
    },
    openDelModel(id) {
      Dialog.confirm({
        title: '删除就诊人',
        message: '确认删除当前选择的就诊人吗？'
      })
        .then(() => {
          // on confirm
          deletePatient(id).then(res => {
            if (res.code == 200) {
              Toast.success('删除成功')
              this.getList()
            } else {
              Toast.fail('删除失败，请重试')
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    onClickLeft() {},
    selectPeople(info) {
      if (this.$route.query.selectPeople == 'select') {
        this.$router.push({
          name: 'payDetail',
          query: {
            patientName: info.patientName,
            patientId: info.patientId,
            ...this.$route.query
          }
        })
      }
      if (this.$route.query.select == 'payList') {
        this.$router.push({
          name: this.$route.query.select,
          query: {
            patientName: info.patientName,
            patientId: info.patientId
          }
        })
      }
      if (this.$route.query.select == 'acidList') {
        this.$router.push({
          name: this.$route.query.select,
          query: {
            patientName: info.patientName,
            patientId: info.patientId
          }
        })
      }
    },
    getList() {
      getPatient().then(res => {
        if (res.data && res.data.length) {
          this.list = res.data
        } else {
          this.list = []
        }
      })
    },
    lookCode() {
      this.$router.push('patientCode')
    },
    addp() {
      if (this.$route.query.selectPeople == 'select') {
        this.$router.push({
          name: 'addPatientForm',
          query: {
            ...this.$route.query
          }
        })
      } else if (this.$route.query.select) {
        this.$router.push({
          name: 'addPatientForm',
          query: {
            select: this.$route.query.select
          }
        })
      } else {
        this.$router.push('addPatientForm')
      }
    }
  }
}
</script>
<style scoped>
.box {
  /* margin-bottom: 50px; */
  height: 100vh;
}

.main {
  width: 100vw;
  height: calc(100vh - 50px);
  overflow-y: auto;
  background: #fff;
}

.people {
  font-size: 18px;
  border-bottom: 1px solid rgb(240, 240, 240);
  padding: 10px 16px;
  color: #323233;
}

.people i {
  position: relative;
  top: 2px;
}

.people span {
  color: #969799;
}

.for {
  border-bottom: 10px solid rgb(242, 248, 253);
  border-top: 1px solid rgb(171, 232, 250);
}

.information {
  font-size: 18px;
  color: #323233;
  padding: 10px 10px 0px 16px;
}

.information span {
  color: #969799;
}

.row {
  margin: 10px 0px;
}

.dis {
  text-align: center;
  font-size: 18px;
  color: rgb(117, 117, 117);
  padding: 5px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer {
  width: 100vw;
  position: fixed;
  height: 70px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}

.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
  font-size: 18px;
}

@font-face {
  font-family: 'iconfont';
  src: url('data:font/truetype;charset=utf-8;base64,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')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-ico:before {
  content: '\e646';
}

@font-face {
  font-family: 'iconfont1';
  src: url('data:font/truetype;charset=utf-8;base64,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')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont1 {
  font-family: 'iconfont1' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-user-wait:before {
  content: '\e6b2';
}
</style>
